// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"385ae1f4","453":"ca73e5aa"}[chunkId] + ".chunk.js";
};